module.exports = __webpack_public_path__ + "static/media/netIQ.4b9f7832.png";